<template>
  <div class="container is-fullhd">
    <section class="signup-hero hero is-primary bookman-gradient">
      <div class="hero-body">
        <div class="container">

          <div class="media">
            <figure class="media-left">
              <p class="image is-128x128">
                <img src="../assets/undraw_Bibliophile_hwqc.svg">
              </p>
            </figure>
            <div class="media-right">
              <h1 class="title">
                Welcome to Bookman
              </h1>
              <h2 class="subtitle">
                Create your free account
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="columns">
        <div class="column is-half is-offset-one-quarter">
          <p class="subtitle"><a @click="goToSignIn">Already have an account? Sign In!</a></p>
          <form @submit.prevent="userSignUp" novalidate>
            <error-message/>
            <b-field label="Email"
                :type="getEmailType"
                :message="getEmailMessage">
                <b-input
                  v-model="email"
                  required
                  @input="$v.email.$touch()"></b-input>
            </b-field>
            <b-field label="Password"
                     :type="getPasswordType"
                     :message="getPasswordMessage">
                <b-input type="password"
                  @input="$v.password.$touch()"
                  v-model="password"
                  required>
                </b-input>
            </b-field>
            <b-field label="Comfirm Password"
                :type="getPasswordConfirmType"
                :message="getPasswordConfirmMessage">
                <b-input type="password"
                  @input="$v.passwordConfirm.$touch()"
                  v-model="passwordConfirm"
                  required>
                </b-input>
            </b-field>
            <button type="submit" v-bind:class="{ 'is-loading': isLocalLoading }" class="button is-primary">
              Sign up
            </button>
          </form>
          <hr>
          <div id="firebaseui-auth-container"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import errorMessage from '@/components/error-message'
import { maxLength, minLength, sameAs } from 'vuelidate/lib/validators'
import firebaseService from '@/services/firebase.service'

export default {
  name: 'signup',
  data () {
    return {
      alert: false,
      email: '',
      password: '',
      passwordConfirm: ''
    }
  },
  mounted () {
    firebaseService.getAuthenticationForm('#firebaseui-auth-container')
  },
  methods: {
    goToSignIn () {
      this.$router.push('/signin')
    },
    async userSignUp () {
      if (this.$v.$invalid) {
        this.$store.commit('setError', 'Form is invalid. Please correct your errors.')
      } else {
        this.$store.dispatch('userSignUp', {
          email: this.email,
          password: this.password
        })
      }
    }
  },
  computed: {
    getEmailMessage () {
      if (this.$v.email.$dirty && !this.$v.email.maxLength) {
        return 'This field must have at most 100 characters'
      }
      return ''
    },
    getEmailType () {
      if (this.$v.email.$dirty && this.$v.email.$invalid) {
        return 'is-danger'
      }
      return ''
    },
    getPasswordConfirmMessage () {
      if (this.$v.passwordConfirm.$dirty && !this.$v.passwordConfirm.sameAsPassword) {
        return 'Password must be identical.'
      }
      return ''
    },
    getPasswordMessage () {
      if (this.$v.password.$dirty && !this.$v.password.minLength) {
        return 'Password must at least 6 characters.'
      }
      return ''
    },
    getPasswordType () {
      if (this.$v.password.$dirty && this.$v.password.$invalid) {
        return 'is-danger'
      }
      return ''
    },
    getPasswordConfirmType () {
      if (this.$v.passwordConfirm.$dirty && this.$v.passwordConfirm.$invalid) {
        return 'is-danger'
      }
      return ''
    },
    isLocalLoading () {
      const localLoading = this.$store.getters.isLocalLoading
      return localLoading.componentId === 'signup' && localLoading.active
    }
  },
  validations: {
    email: {
      maxLength: maxLength(100)
    },
    password: {
      minLength: minLength(6)
    },
    passwordConfirm: {
      sameAsPassword: sameAs('password')
    }
  },
  components: {
    errorMessage
  }
}
</script>

<style scoped>
  @import "../../node_modules/firebaseui/dist/firebaseui.css";
  .signup-hero {
    margin-top: 50px;
  }
</style>
